"use client";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useDeleteFormFull } from "@/hooks/form/use-form";
import React from "react";
import { useTranslation } from "react-i18next";

interface DeleteFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  formId: string;
  formName: string;
}

const DeleteFormModal: React.FC<DeleteFormModalProps> = ({
  isOpen,
  onClose,
  formId,
  formName,
}) => {
  const { t } = useTranslation();
  const deleteMutation = useDeleteFormFull();

  const handleDelete = async () => {
    await deleteMutation.mutateAsync(formId);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t('common.delete')} {t('formManagement.formName')}</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <p className="text-sm text-gray-600">
            {t('common.warning')}: This action will permanently delete the form "{formName}" and all associated data including responses, processes, and configurations. This cannot be undone.
          </p>

          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={onClose}>
              {t('common.cancel')}
            </Button>
            <Button
              onClick={handleDelete}
              disabled={deleteMutation.isPending}
              variant="destructive"
            >
              {deleteMutation.isPending ? t('common.loading') : t('common.delete')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteFormModal;
